import { useReducer } from 'react'
import type { ActivationFlowAction, ActivationFlowModel } from './ActivationFlow.types'
import { initialActivationFlowState } from './activationFlowInitialState'
import { reduceActivationRecoveryAction } from './activationFlowRecoveryReducer'
import { reduceActivationSetupAction } from './activationFlowSetupReducer'
import { reduceActivationTokenAction } from './activationFlowTokenReducer'

const activationFlowReducer = (
  state: ActivationFlowModel,
  action: ActivationFlowAction,
): ActivationFlowModel =>
  reduceActivationTokenAction(state, action) ??
  reduceActivationSetupAction(state, action) ??
  reduceActivationRecoveryAction(state, action) ??
  state

export const useActivationFlowReducer = () => useReducer(activationFlowReducer, initialActivationFlowState)
